module.exports = __webpack_public_path__ + "static/img/areaB_2.036ba8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_2.png
// module id = 1274
// module chunks = 1